import React, { useRef, useState } from "react";
import { Upload, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/contexts/AuthContext";

export function ImageUpload({ onUploaded, testid = "img-upload" }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const pick = async (file) => {
    if (!file) return;
    if (!/^image\/(png|jpeg|gif|webp)$/.test(file.type)) { toast.error("PNG, JPG, GIF or WebP only"); return; }
    if (file.size > 5 * 1024 * 1024) { toast.error("Max 5 MB"); return; }
    setBusy(true);
    const fd = new FormData(); fd.append("file", file);
    try { const { data } = await api.post("/email-campaigns/images", fd, { headers: { "Content-Type": "multipart/form-data" } }); onUploaded(`${process.env.REACT_APP_BACKEND_URL}${data.path}`); toast.success("Image uploaded"); }
    catch (e) { toast.error(formatApiError(e?.response?.data?.detail) || "Upload failed"); } finally { setBusy(false); if (ref.current) ref.current.value = ""; }
  };
  return (
    <>
      <input ref={ref} type="file" accept="image/png,image/jpeg,image/gif,image/webp" className="hidden" onChange={(e) => pick(e.target.files?.[0])} data-testid={`${testid}-input`} />
      <button type="button" disabled={busy} onClick={() => ref.current?.click()} className="w-full h-9 flex items-center justify-center gap-1.5 text-xs font-bold rounded-sm border border-dashed border-[#0B132B] text-[#0B132B] hover:bg-[#F8F9FA] disabled:opacity-50" data-testid={`${testid}-btn`}>
        {busy ? <Loader2 size={12} className="animate-spin" /> : <Upload size={12} />} {busy ? "Uploading…" : "Upload image from my computer"}
      </button>
    </>
  );
}
